import { useState } from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import Icon from 'components/Icon';
import { Alert } from './index.view';
import { get } from 'lodash-es';
import { IconName } from 'constants/status';

const useAlert = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [key, setKey] = useState('');
  const [options, setOptions] = useState({
    anchorOrigin: { horizontal: 'right', vertical: 'top' },
    autoHideDuration: 7000,
  });

  const alert = (message = 'Alert', { variant = 'success', ...restOptions } = {}) => {
    setOptions((preOptions) => ({
      ...preOptions,
      ...options,
    }));

    const newOptions = {
      ...options,
      ...restOptions,
    };

    const iconName = get(IconName, variant);
    const alertKey = enqueueSnackbar(message, {
      content: (key) => (
        <Alert
          severity={variant}
          icon={iconName && <Icon name={iconName} />}
          onClose={closeAlert(key)}
        >
          {message}
        </Alert>
      ),
      ...newOptions,
    });
    setKey(alertKey);
    return alertKey;
  };

  const closeAlert = (key) => () => {
    closeSnackbar(key);
  };

  return {
    alert, // for using alert box;
    closeAlert, // for close alert box
    key, // key fo alert box
  };
};
useAlert.IconName = IconName;

export { useAlert, SnackbarProvider };
